import React, { useState } from 'react';
import {
  Box,
  Divider,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Typography,
  IconButton
} from '@mui/material';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import koLocale from '@fullcalendar/core/locales/ko';
import '@fullcalendar/common/main.min.css';
import '@fullcalendar/daygrid/main.min.css';
//import './calendar.css'

function renderEventContent(eventInfo) {
  //console.log(eventInfo.event.extendedProps,'eventInfo');
  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
        <Typography variant="subtitle2" component="div">{eventInfo.event.title}</Typography>
        {eventInfo.event.extendedProps?.usrNm && (
          <>
            <Typography variant="body2"> - 작업예정자:{eventInfo.event.extendedProps?.usrNm}</Typography>
            <Typography variant="body2">{eventInfo.event.extendedProps?.gradeNm}</Typography>
            <Typography variant="body2" sx={{ mx: 1 }}>(부서:{eventInfo.event.extendedProps?.dptNm})</Typography>
          </>
        )}

        {eventInfo.timeText && <Typography variant="body2">{eventInfo.timeText}</Typography>}
      </Box>
    </>
  );
}
//https://github.com/fullcalendar/fullcalendar-example-projects/blob/master/react-redux/src/DemoApp.jsx
const DashboardCalendar = ({ events, handelEventClick, toggleCalFull, full }) => {
  const [weekendsVisible, setWeekendsVisible] = useState(true);
  const handleChange = () => {
    setWeekendsVisible(!weekendsVisible);
  };

  // console.log(events,"events");



  return (
    <Box
      sx={{
        px: 2,
        mb: 2
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox checked={weekendsVisible} onChange={handleChange} />
              }
              label="토,일 포함"
            />
          </FormGroup>
        </Box>
        <Box>
          <IconButton size="large" onClick={toggleCalFull}>
            {full ? (<CloseFullscreenIcon />) : (<OpenInFullIcon />)}
          </IconButton>
        </Box>
      </Box>
      <Divider sx={{ my: 1 }} />
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: 'dayGridMonth,timeGridWeek,timeGridDay',
        }}
        height={full ? '1200px' : '600px'}
        adapterLocale="ko"
        initialView="dayGridMonth"
        weekends={weekendsVisible}
        nextDayThreshold="09:00:00"
        events={events}
        eventContent={renderEventContent}
        nowIndicator
        dateClick={(e) => console.log(e.dateStr)}
        eventClick={(e) => handelEventClick(e)}
      />
    </Box>
  );
};

export default DashboardCalendar;
